import './StoresPage.less';

export const prefix = 'bm-p-stores';

export { default } from './StoresPage';
